import { useDispatch } from 'react-redux'
import { ServiceOrderPhone } from 'components'
import { setStage } from 'slices/drawer'
import { FIREBASE_EVENTS } from 'app-constants'
import { useFirebaseEvent } from 'hooks'
import { ADDRESS_CHANGE_STAGES } from '../../constants'

export function PhoneSelection({ setContactNote }) {
  const dispatch = useDispatch()
  const { sendEvent } = useFirebaseEvent()

  function handleSelectedPhone(phone) {
    setContactNote(phone)
    sendEvent(FIREBASE_EVENTS.ADDRESS_CHANGE_PHONE_SELECTION)
    dispatch(setStage(ADDRESS_CHANGE_STAGES.CONFIRMATION))
  }

  return <ServiceOrderPhone onSelectPhone={handleSelectedPhone} />
}
